import React from 'react';
import './style.scss';
import { getTenantIdentity } from 'hooks/useTenantIdentity';
import { useAppSelector } from '../../../careand-redux/store';
import { TenantAsset } from '../../../careand-redux/selectors';
import TenantImg from '../../TenantImg';

const OldVersionScreen = () => {
  const logo = useAppSelector(TenantAsset('logo_white'));

  return (
    <div className="old-version-screen">
      <TenantImg src="logo_white" width="230" className="mb-5" />
      <span className="center-text white-text centered">
        You are currently using an outdated version of the {getTenantIdentity().name} web app.
        Please refresh this page or clear your browser's cache in order to access our service.
      </span>
    </div>
  );
};

export default OldVersionScreen;
